<template>
    <div>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>

        <el-tabs v-if="isShow" class="mt10" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="查找" :name="activeNameMap.search" v-if="showSearch">
                <swb-servicer-list-select ref="swb_servicer_list_for_select_search" :name="activeNameMap.search" :multiSelect="multiSelect" :multiSelectDisabled="multiSelectDisabled" :initCheckedIds="initCheckedIds" :checkedItem="checkedItem" :checkedIds="checkedIds" :checkedList="checkedList" :seachQueryModel="queryModel" :operation="operation" @handle-change="handleChange"></swb-servicer-list-select>
            </el-tab-pane>
            <el-tab-pane label="默认" :name="activeNameMap.def" v-if="showDef">
                <swb-servicer-list-select ref="swb_servicer_list_for_select_def" :servcType="servcType" :devcGroupId="devcGroupId" :devcDefIds="devcDefIds" :name="activeNameMap.def" :multiSelect="multiSelect" :multiSelectDisabled="multiSelectDisabled" :initCheckedIds="initCheckedIds" :checkedItem="checkedItem" :checkedIds="checkedIds" :checkedList="checkedList" :seachQueryModel="queryModel" :operation="operation" @handle-change="handleChange"></swb-servicer-list-select>
            </el-tab-pane>
            <el-tab-pane label="合同" :name="activeNameMap.contract" v-if="showContract">
                <swb-servicer-list-select ref="swb_servicer_list_for_select_contract" :name="activeNameMap.contract" :multiSelect="multiSelect" :multiSelectDisabled="multiSelectDisabled" :initCheckedIds="initCheckedIds" :checkedItem="checkedItem" :checkedIds="checkedIds" :checkedList="checkedList" :seachQueryModel="queryModel" :operation="operation" @handle-change="handleChange"></swb-servicer-list-select>
            </el-tab-pane>
            <el-tab-pane label="订单" :name="activeNameMap.order" v-if="showOrder">
                <swb-servicer-list-select ref="swb_servicer_list_for_select_order" :name="activeNameMap.order" :multiSelect="multiSelect" :multiSelectDisabled="multiSelectDisabled" :initCheckedIds="initCheckedIds" :checkedItem="checkedItem" :checkedIds="checkedIds" :checkedList="checkedList" :seachQueryModel="queryModel" :operation="operation" @handle-change="handleChange"></swb-servicer-list-select>
            </el-tab-pane>
            <el-tab-pane label="双方关联" :name="activeNameMap.ambilateralBizRel" v-if="showAmbilateralBizRel">
                <swb-servicer-list-select ref="swb_servicer_list_for_select_ambilateralBizRel" :name="activeNameMap.ambilateralBizRel" :multiSelect="multiSelect" :multiSelectDisabled="multiSelectDisabled" :initCheckedIds="initCheckedIds" :checkedItem="checkedItem" :checkedIds="checkedIds" :checkedList="checkedList" :seachQueryModel="queryModel" :operation="operation" @handle-change="handleChange"></swb-servicer-list-select>
            </el-tab-pane>
            <el-tab-pane label="租赁备选" :name="activeNameMap.bizRel" v-if="showBizRel">
                <swb-servicer-list-select ref="swb_servicer_list_for_select_bizRel" :name="activeNameMap.bizRel" :multiSelect="multiSelect" :multiSelectDisabled="multiSelectDisabled" :initCheckedIds="initCheckedIds" :checkedItem="checkedItem" :checkedIds="checkedIds" :checkedList="checkedList" :seachQueryModel="queryModel" :operation="operation" @handle-change="handleChange"></swb-servicer-list-select>
            </el-tab-pane>
            <el-tab-pane label="卖方关联" :name="activeNameMap.adverseBizRel" v-if="showAdverseBizRel">
                <swb-servicer-list-select ref="swb_servicer_list_for_select_adverseBizRel" :name="activeNameMap.adverseBizRel" :multiSelect="multiSelect" :multiSelectDisabled="multiSelectDisabled" :initCheckedIds="initCheckedIds" :checkedItem="checkedItem" :checkedIds="checkedIds" :checkedList="checkedList" :seachQueryModel="queryModel" :operation="operation" @handle-change="handleChange"></swb-servicer-list-select>
            </el-tab-pane>
            <el-tab-pane label="待入围" :name="activeNameMap.noScoreBizRel" v-if="showNoScoreBizRel">
                <swb-servicer-list-select ref="swb_servicer_list_for_select_noScoreBizRel" :name="activeNameMap.noScoreBizRel" :multiSelect="multiSelect" :multiSelectDisabled="multiSelectDisabled" :initCheckedIds="initCheckedIds" :checkedItem="checkedItem" :checkedIds="checkedIds" :checkedList="checkedList" :seachQueryModel="queryModel" :operation="operation" @handle-change="handleChange"></swb-servicer-list-select>
            </el-tab-pane>
            <el-tab-pane label="加黑" :name="activeNameMap.shieldedBizRel" v-if="showShieldedBizRel">
                <swb-servicer-list-select ref="swb_servicer_list_for_select_shieldedBizRel" :name="activeNameMap.shieldedBizRel" :multiSelect="multiSelect" :multiSelectDisabled="multiSelectDisabled" :initCheckedIds="initCheckedIds" :checkedItem="checkedItem" :checkedIds="checkedIds" :checkedList="checkedList" :seachQueryModel="queryModel" :operation="operation" @handle-change="handleChange"></swb-servicer-list-select>
            </el-tab-pane>
            <el-tab-pane label="全部" :name="activeNameMap.all" v-if="showAll">
                <swb-servicer-list-select ref="swb_servicer_list_for_select_all" :name="activeNameMap.all" :multiSelect="multiSelect" :multiSelectDisabled="multiSelectDisabled" :initCheckedIds="initCheckedIds" :checkedItem="checkedItem" :checkedIds="checkedIds" :checkedList="checkedList" :seachQueryModel="queryModel" :operation="operation" @handle-change="handleChange"></swb-servicer-list-select>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import { Utils, EventBus } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import SwbComnForSelect from './ComnForSelect';
    Vue.regist(SwbComnForSelect);

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    import rentServcApi from '../../api/rentServc';

    let searchConfigData = {
        "queryFields": [{
            "type": "Text",
            "label": "商户名称",
            "code": "name",
            "basic": true,
            "valueType": "String"
        }, {
            "type": "Checkbox",
            "label": "业务关系未到期",
            "code": "unexpired",
            "basic": true,
            "valueType": "Boolean",
            "hidden": true,
            "value": true
        }, {
            "type": "Num2",
            "label": "注册资金(元)",
            "code": "registCapital",
            "basic": true,
            "valueType": "Float"
        }, {
            "type": "Text",
            "label": "注册地址",
            "code": "regionName",
            "basic": true,
            "valueType": "String"
        }, {
            "type": "Num2",
            "label": "星级标记",
            "code": "starLevel",
            "basic": false,
            "valueType": "Integer",
            "hidden": true
        }, {
            "type": "Date2",
            "label": "注册日期",
            "code": "foundDate",
            "basic": false,
            "valueType": "String"
        }]
    };

    let searchConfigData2 = {
        "queryFields": [{
            "type": "Text",
            "label": "商户名称",
            "code": "exactName",
            "basic": true,
            "valueType": "String"
        }, {
            "type": "Text",
            "label": "商户编码",
            "code": "exactNo",
            "basic": true,
            "valueType": "String"
        }, {
            "type": "Text",
            "label": "统一社会信用代码",
            "code": "exactSocialCreditCode",
            "basic": true,
            "valueType": "String"
        }]
    };

    let activeNameMap = {
        search: "search",
        def: "def",
        contract: "contract",
        order: "order",
        ambilateralBizRel: "ambilateralBizRel",
        bizRel: "bizRel",
        adverseBizRel: "adverseBizRel",
        noScoreBizRel: "noScoreBizRel",
        shieldedBizRel: "shieldedBizRel",
        all: "all"
    };

    //
    export default {
        name: 'swb-servicer-for-comn-select',
        desc: '服务商-通用选择(支持多选,单选)',
        props: {
            showSearch: { // 展示合同服务商，默认不展示
                type: Boolean,
                default: false
            },
            showDef: { // 展示合同服务商，默认不展示
                type: Boolean,
                default: false
            },
            showContract: { // 展示合同服务商，默认不展示
                type: Boolean,
                default: false
            },
            showOrder: { // 展示订单服务商，默认不展示
                type: Boolean,
                default: false
            },
            showAmbilateralBizRel: { // 展示双向关联服务商，默认不展示
                type: Boolean,
                default: false
            },
            showBizRel: { // 展示客户关系服务商，默认展示
                type: Boolean,
                default: false
            },
            showAdverseBizRel: { // 展示对方关联服务商，默认展示
                type: Boolean,
                default: false
            },
            showNoScoreBizRel: { // 展示没有评分服务商，默认展示
                type: Boolean,
                default: false
            },
            showShieldedBizRel: { // 展示加黑服务商，默认展示
                type: Boolean,
                default: false
            },
            showAll: { // 展示全部服务商，默认展示
                type: Boolean,
                default: false
            },
            multiSelect: {
                type: Boolean,
                default: true
            },
            multiSelectDisabled: {
                type: Boolean,
                default: false
            },
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            servcType: {
                type: Number,
                default: null
            },
            devcGroupId: {  // 默认服务商-根据分类分组过滤
                type: Number,
                default: null
            },
            devcDefIds: {  // 默认服务商-根据型号id过滤
                type: Array,
                default: function () {
                    return [];
                }
            },
            //单选初始选择项
            initCheckedId: {
                type: Number,
                default: null
            },
            //多选初始选择项
            initCheckedIds: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            },
            warnMessage: { // 警告提示
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {
                activeNameMap: activeNameMap,
                //排序、搜索
                queryConfig: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                activeName: null,
                checkedId: null,
                checkedIds: [],
                checkedList: [],
                checkedItem: {},
                operation: null,
                isShow: false

            }
        },
        created: function () {
            this.queryConfig = searchConfigData || {};
            //
            this.activeName = this.getActiveName();
            if(this.multiSelect) {
                if(this.multiSelectDisabled == null || this.multiSelectDisabled == false) {
                    let checkedIds = this.initCheckedIds;
                    this.checkedIds = checkedIds;
                    if(!Utils.isNoB(checkedIds) && checkedIds.length > 0) {
                        this.getMerchantDtoList();
                    } else {
                        this.isShow = true;
                    }
                } else {
                    this.isShow = true;
                }
            } else {
                this.checkedId = this.initCheckedId || null;
                if(this.checkedId != null) {
                    this.getMerchantDto();
                } else {
                    this.isShow = true;
                }
            }
        },
        methods: {
            getActiveName: function () {
                let activeNameItem = this.activeNameMap;
                if(this.showDef) {
                    return activeNameItem.def;
                } else if(this.showContract) {
                    return activeNameItem.contract;
                } else if(this.showOrder) {
                    return activeNameItem.order;
                } else if(this.showAmbilateralBizRel) {
                    return activeNameItem.ambilateralBizRel;
                } else if(this.showBizRel) {
                    return activeNameItem.bizRel;
                } else if(this.showAdverseBizRel) {
                    return activeNameItem.adverseBizRel;
                } else if(this.showNoScoreBizRel) {
                    return activeNameItem.noScoreBizRel;
                } else if(this.showShieldedBizRel) {
                    return activeNameItem.shieldedBizRel;
                } else if(this.showAll) {
                    return activeNameItem.all;
                } else if(this.showSearch) {
                    this.queryConfig = searchConfigData2 || {};
                    return activeNameItem.search;
                }
            },
            handleClick(tab, event) {
                let activeName = this.activeName;
                let activeNameItem = this.activeNameMap;
                let queryConfig = Utils.merge({}, searchConfigData);
                if(activeName == activeNameItem.search) {
                    queryConfig = Utils.merge({}, searchConfigData2);
                } else {
                    let queryConfigMap = queryConfig.queryFields.toMap("code");
                    let unexpiredItem = queryConfigMap['unexpired'];
                    let foundDateItem = queryConfigMap['starLevel'];
                    //
                    if(activeName == activeNameItem.contract || activeName == activeNameItem.order || activeName == activeNameItem.all) {
                        unexpiredItem.hidden = true;
                        foundDateItem.hidden = true;
                    } else {
                        unexpiredItem.hidden = false;
                        foundDateItem.hidden = false;
                    }
                }
                this.queryConfig = Utils.merge({}, queryConfig);
            },
            handleChange: function (item) {
                if(this.multiSelect) {
                    let checkedIds = item.checkedIds || [];
                    let checkedList = item.checkedList || [];
                    this.operation = item.operation;
                    this.checkedIds = Utils.merge([], checkedIds);
                    this.checkedList = Utils.merge([], checkedList);
                } else {
                    let checkedItem = item.checkedItem;
                    this.operation = item.operation;
                    this.checkedItem = Utils.merge({}, checkedItem)
                }
            },
            //
            queryHandler(queryModel) {
                //缓存查询条件
                this.operation = this.activeName;
                this.queryModel = Utils.merge({}, queryModel);
            },
            getMerchantDtoList: function () {
                let self = this;
                let postData = {};
                postData.ids = this.initCheckedIds;
                //
                let theLoad = MsgBox.loading();
                rentServcApi.getMerchantDtoListByIds(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        self.checkedList = result.data;
                        self.isShow = true;
                        //
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getMerchantDto: function () {
                let self = this;
                let postData = {};
                postData.id = this.initCheckedId;
                //
                let theLoad = MsgBox.loading();
                rentServcApi.getMerchantDtoById(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        self.checkedItem = result.data;
                        self.isShow = true;
                        //
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            getDlgResult: function () {
                let warnMessage = this.warnMessage == null ? true : this.warnMessage;
                //
                let result = {};
                result.type = "info";
                if(this.multiSelect) {
                    //
                    let checkedIds = this.checkedIds || [];
                    let checkedList = this.checkedList || [];
                    if(warnMessage) {
                        if(Utils.isNoB(checkedIds) || checkedIds.length <= 0) {
                            result.type = "warn";
                            result.message = "请至少选择一个商户！";
                            return result;
                        }
                    }
                    result.checkedIds = checkedIds;
                    result.data = checkedList;
                } else {
                    let checkedItem = this.checkedItem || {};
                    if(warnMessage) {
                        if(Utils.isNoB(checkedItem) || Utils.isNoB(checkedItem.id)) {
                            result.type = "warn";
                            result.message = "请选择商户！";
                            return result;
                        }
                    }
                    result.checkedId = checkedItem.id || null;
                    result.data = checkedItem;
                }
                //
                return result;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/rentServc/ServicerForComnSelect.vue